import { useContext } from "react";
import React from "react";
import { DataSourceContextProps } from "./datasource-types";

// Re-export the extracted modules so every existing `from ".../datasource"`
// import keeps working unchanged.
export * from "./datasource-types";
export * from "./datasource-schema";
export * from "./datasource-execution";

/// TODO : REMOVE

export const DataSourceContext = React.createContext<DataSourceContextProps | undefined>(undefined);

export function useDataSourceContext() {
    return useContext(DataSourceContext)
}
